define('modules/player/player_form_model',['backbone',
  '_',
  'session',
  'modules/form/form_item_collection',
  'modules/form/form_section_model'
], function (Backbone, _, session,
             FormItemCollection,
             FormSectionModel) {
  'use strict';
  var Model = Backbone.Model.extend({
    parse: function (response, options) {
      var respond = {},
        sections = new Backbone.Collection();

      _.forEach(response.sections, function (section) {
        var sectionModel = new FormSectionModel(section);

        var itemCollection = new FormItemCollection(section.fields);
        sectionModel.set({fields: itemCollection});
        sections.add(sectionModel);
      });

      delete response.sections;

      _.extend(respond, response);
      _.extend(respond, {sections: sections});

      return respond;
    },

    url: function () {
			return session.get('apiUrl') + 'players/' + this.get('id') + '/form';
    }
  });

  return Model;
});

